module.exports = __webpack_public_path__ + "img/placeholder-portrait.b3a0c4e9.svg";